// =============================================================================
// LegendRow.tsx
// Single legend entry — colour swatch + name + value. Staggered fade-and-slide
// in on mount, indexed by `index` so a list reads as a cascade.
// =============================================================================

import React, { useEffect, useState } from 'react';

interface LegendRowProps {
  color: string;
  name: string;
  value: React.ReactNode;
  index: number;
  fontSize?: number | string;
}

export function LegendRow({ color, name, value, index, fontSize = 'var(--m-text-label)' }: LegendRowProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { const t = setTimeout(() => setMounted(true), 200 + index * 60); return () => clearTimeout(t); }, [index]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6, fontSize,
      marginBottom: 3,
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateX(0)' : 'translateX(-6px)',
      transition: 'opacity 0.4s ease, transform 0.4s ease',
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 2, background: color, flexShrink: 0 }} />
      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</span>
      <span>{value}</span>
    </div>
  );
}
